<!--
Author: TangChen
Date: 2018-11-16
Desc: 支持银行卡
 -->
<template>
    <div v-if="bankLists.length > 0" class="bizcomp-support-bank-dc">
        <div v-for="(bank, index) of bankLists" :key="index">
            <div
                :class="
                    'bank-img ' +
                    (index % 5 == 4 ? '' : 'margin-right-16 ') +
                    (index < 5 ? '' : 'margin-top-16')
                "
            >
                <img :src="$util.getImg(bank.bankcode)" alt="" />
                <span
                    class="k-text-flow"
                    :class="{ fonts: bank.fullname.length >= 6 }"
                    :title="bank.fullname"
                >
                    {{ bank.fullname.toString().substr(0, 6) }}
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userApi from "@/api/user";
import conf from "@/config/index";

export default {
    name: "SupportBank",
    mixins: [mixin],
    props: {
        paychannelbankInfoList: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    data() {
        return {
            bankLists: []
        };
    },
    mounted() {
        this.getBankInfo();
    },
    methods: {
        async getBankInfo() {
            if (this.paychannelbankInfoList.length > 0) {
                let _arr = this.paychannelbankInfoList;
                let bank = [];
                const x = {};
                _arr = _arr.filter((item) => {
                    return item.specialflag && item.specialflag.includes("0");
                });
                // 合并银行卡
                for (let i of _arr) {
                    const _x = i.fullname.indexOf("-");
                    if (_x > -1) {
                        i.fullname = i.fullname.substring(_x + 1);
                    }
                    if (i.channelid === conf.const.TTY_CHANLEID) {
                        i.bankcode = "TTY";
                    }
                    if (!x[i.bankcode]) {
                        i.child = [];
                        i.child.push(i);
                        bank.push(i);
                        x[i.bankcode] = true;
                    } else {
                        for (let j of bank) {
                            if (j.bankcode === i.bankcode) {
                                j.child.push(i);
                            }
                        }
                    }
                }
                this.bankLists = bank;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-support-bank-dc {
    display: flex;
    flex-wrap: wrap;
    .bank-img {
        height: 68px;
        width: 219px;
        display: flex;
        align-items: center;
        padding-left: 27px;
        border-radius: 2px;
        background: #ffffff;
        box-sizing: border-box;
        border: 1px solid #e4e4e4;
        img {
            width: 36px;
            height: 36px;
        }
        span {
            font-size: 20px;
            font-weight: 500;
            font-feature-settings: "kern" on;
            color: #3d3d3d;
            padding-left: 8px;
        }
    }
    .margin-right-16 {
        margin-right: 16px;
    }
    .margin-top-16 {
        margin-top: 16px;
    }
}
</style>
